
<template>
<div>
  <multiselect v-model="value" deselect-label="Can't remove this value"
  track-by="cityName" label="cityName"
  placeholder="Select one" :options="cityInventorylist" :searchable="false" :allow-empty="false"  @select="changeSelection($event)">
    <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.cityName }}</strong> is written in<strong>  {{ option.shipId }}</strong></template>
  </multiselect>

</div>
</template>

<script>
import Multiselect from "vue-multiselect";



export default {
  name: "SelectorCity",
  props: ["cityInventorylist"],
  components: { Multiselect },
  data() {
    return {
      value: null,
  options: [
// {cityId:0,
// cityName:"City1"}
    ],
    };
  },
  methods: {
    changeSelection(event) {
 this.$emit("changedSelect", event);
    },
    limitText(count) {
      return `and ${count} other Cities`;
    },
  
    alertme: function() {},
    setSelection: function(newValue) {
      this.value = newValue;
    },
    returnSelection: function() {
      return this.value;
    }
  }
};
</script>


<style src="vue-multiselect/dist/vue-multiselect.css"></style>

